import { render, staticRenderFns } from "./Viz.vue?vue&type=template&id=5b8e7588&"
import script from "./Viz.vue?vue&type=script&lang=js&"
export * from "./Viz.vue?vue&type=script&lang=js&"
import style0 from "./Viz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports